// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__3jGjx","section":"section__34f86","column":"column__3Ryfn","text":"text__1S85L"};


//////////////////
// WEBPACK FOOTER
// ./components/section/style.styl
// module id = 2d+l
// module chunks = 0